import { useCoursesLoaderData } from "./coursesLoader";

export const usePreferredShippingAddress = () => {
  const { shippingAddresses } = useCoursesLoaderData();

  const preferredShippingAddress = shippingAddresses?.find(
    (address) => address.preferred === true
  );

  return {
    preferredShippingAddress,
  };
};
